exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-type__container{--items-gap:2px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:2px 0;padding:var(--items-gap,2px) 0;margin-left:-2px;margin-left:calc(-1*var(--items-gap, 2px))}", ""]);

// exports
